export const theme = {
  background: '#F9F8F6',
  fontFamily: 'Marianne, arial, sans-serif',
  textColor:  '#6A6A6A',
  fontSize:   13,
};
